<!-- IconNewImprint.vue - "Start New Imprint" icon (alert/new-releases) -->
<template>
  <svg 
    width="35" 
    height="35" 
    viewBox="0 0 33 31" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="icon-new-imprint"
  >
    <path 
      d="M32.0833 15.2542L28.525 11.2L29.0208 5.83333L23.7563 4.6375L21 0L16.0417 2.12917L11.0833 0L8.32708 4.6375L3.0625 5.81875L3.55833 11.1854L0 15.2542L3.55833 19.3083L3.0625 24.6896L8.32708 25.8854L11.0833 30.5229L16.0417 28.3792L21 30.5083L23.7563 25.8708L29.0208 24.675L28.525 19.3083L32.0833 15.2542ZM17.5 22.5458H14.5833V19.6292H17.5V22.5458ZM17.5 16.7125H14.5833V7.9625H17.5V16.7125Z" 
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconNewImprint'
};
</script>

<style scoped>
.icon-new-imprint {
  display: block;
}
</style>
